import type React from 'react';
import { useEffect, useState } from 'react';
import FallbackPersonImage from '../../assets/fallback-person-image.png';

interface ImageComponentProps {
  webpSrc?: string;
  src: string;
  errorFallbackSrc?: string;
  className?: string;
  alt: string;
  onClick?: () => void; // Add onClick prop
  lazy?: boolean;
}

const Image: React.FC<ImageComponentProps> = ({
  webpSrc,
  src,
  errorFallbackSrc,
  className,
  alt,
  onClick, // Destructure onClick
  lazy = false,
}) => {
  const [fallbackSrc, setFallbackSrc] = useState(src);

  useEffect(() => {
    setFallbackSrc(src);
  }, [src]);

  const handleError = () => {
    setFallbackSrc(errorFallbackSrc ?? FallbackPersonImage);
  };

  return (
    <picture className={className}>
      {webpSrc && <source type="image/webp" srcSet={webpSrc} />}
      <source type="image/jpeg" srcSet={fallbackSrc} />
      <img
        src={fallbackSrc}
        style={{ width: '100%', height: '100%' }}
        className={className}
        onError={handleError}
        alt={alt}
        onClick={onClick} // Attach onClick handler here
        loading={lazy ? 'lazy' : 'eager'}
      />
    </picture>
  );
};

export default Image;
